// @constants
const actionTypes = require('../constants/actionTypes');

const requestProfileSuccess = lang => ({
    type: actionTypes.FETCH_PROFILE_SUCCESS,
    payload: {
        lang
    }
});


module.exports = {
    requestProfileSuccess
};
